export default __webpack_public_path__ + "static/media/pexels-kindel-media-7979606.f30bce46.jpg";